import React from 'react'
import { HeadWrapper, HeadTitle } from './Headstyle'

function Servicehead() {
    return (
        <>
            <HeadWrapper>
                <HeadTitle data-aos='zoom-in'>
                    <h1>Services</h1>
                    <p>We got you covered by providing you our services ranging from planning, designing, development, up until to the launching of your project or business, as we handle each project with creativity and connection to its owner. Take a moment to go through some of our services since we want our users to be informed about the services that they wish to avail.</p>
                </HeadTitle>
            </HeadWrapper>
        </>
    )
}

export default Servicehead
